export default __webpack_public_path__ + "static/ux-strategy-2--aa9de673d2f5f848cf63161fb56f31e6.png";